export function arrayOfEntriesToObject(arr) {
  let nonNullArray;

  if (!arr) {
    nonNullArray = new Array(5).fill("");
  } else {
    nonNullArray = arr;
  }

  return nonNullArray.reduce(
    (acc, curr, index) => ({ ...acc, [index]: curr }),
    {}
  );
}
